// Cookie管理工具 - 纯Cookie认证系统
export const cookieManager = {
  // 设置cookie
  setCookie(name, value, days = 7) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    const expiresString = `expires=${expires.toUTCString()}`;
    const path = 'path=/';
    const protocolSecure = window.location.protocol === 'https:' ? '; secure' : '';
    const hostname = window.location.hostname || '';
    const isProdDomain = hostname.endsWith('.lvbaobao.space');
    const domain = isProdDomain ? '; domain=.lvbaobao.space' : '';
    const sameSite = isProdDomain ? '; samesite=none' : '; samesite=strict';
    const secure = isProdDomain ? '; secure' : protocolSecure;
    
    document.cookie = `${name}=${encodeURIComponent(value)}; ${expiresString}; ${path}${domain}${secure}${sameSite}`;
  },

  // 获取cookie
  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  },

  // 删除cookie
  deleteCookie(name) {
    const hostname = window.location.hostname || '';
    const isProdDomain = hostname.endsWith('.lvbaobao.space');
    const domain = isProdDomain ? '; domain=.lvbaobao.space' : '';

    // 删除时需要指定相同的 domain
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domain}`;
  },

  // 检查cookie是否存在
  hasCookie(name) {
    return this.getCookie(name) !== null;
  },

  // 获取所有cookie
  getAllCookies() {
    const cookies = {};
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      const eqIndex = c.indexOf('=');
      if (eqIndex > 0) {
        const name = c.substring(0, eqIndex);
        const value = decodeURIComponent(c.substring(eqIndex + 1));
        cookies[name] = value;
      }
    }
    return cookies;
  },

  // 清除所有认证相关的cookie
  clearAuthCookies() {
    this.deleteCookie('sessionId'); // 会话ID
    this.deleteCookie('userEmail');
    this.deleteCookie('isLoggedIn');
    this.deleteCookie('applicationId');
  },

  // 设置展示用的登录信息；认证会话 lb_session 由后端 HttpOnly Cookie 管理
  setAuthInfo(token, email, isLoggedIn = true) {
    // token 参数仅保留兼容调用方；前端不得写认证 Cookie
    this.setCookie('userEmail', email, 7);
    this.setCookie('isLoggedIn', isLoggedIn.toString(), 7);
  },

  // 获取认证信息
  getAuthInfo() {
    return {
      token: null, // 纯Cookie认证不使用JWT token
      email: this.getCookie('userEmail'),
      isLoggedIn: this.getCookie('isLoggedIn') === 'true',
      sessionId: this.getCookie('sessionId') // 会话ID
    };
  },

  // 检查是否已登录（基于用户邮箱和登录状态）
  isLoggedIn() {
    const email = this.getCookie('userEmail');
    const isLoggedIn = this.getCookie('isLoggedIn') === 'true';
    return isLoggedIn && !!email;
  },

  // 获取认证token（返回null，纯Cookie认证不需要JWT）
  getAuthToken() {
    return null; // 纯Cookie认证不使用JWT token
  },

  // 获取会话ID（用于后端验证）
  getSessionId() {
    return this.getCookie('sessionId');
  },

  // 获取用户邮箱
  getUserEmail() {
    return this.getCookie('userEmail');
  },

  // 设置应用ID
  setApplicationId(applicationId) {
    this.setCookie('applicationId', applicationId, 7);
  },

  // 获取应用ID
  getApplicationId() {
    return this.getCookie('applicationId');
  },

  // 设置表单相关数据（临时数据，保存时间较短）
  setFormData(key, data, days = 1) {
    this.setCookie(key, JSON.stringify(data), days);
  },

  // 获取表单相关数据
  getFormData(key) {
    const data = this.getCookie(key);
    return data ? JSON.parse(data) : null;
  },

  // 删除表单相关数据
  deleteFormData(key) {
    this.deleteCookie(key);
  }
};

// 为了兼容性，提供localStorage风格的API
export const cookieStorage = {
  getItem: (key) => cookieManager.getCookie(key),
  setItem: (key, value) => cookieManager.setCookie(key, value, 7),
  removeItem: (key) => cookieManager.deleteCookie(key),
  clear: () => cookieManager.clearAuthCookies()
};

export default cookieManager;
